const Headphone = (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#F8F6FF" />
    <path
      d="M15 30V24C15 21.6131 15.9482 19.3239 17.636 17.636C19.3239 15.9482 21.6131 15 24 15C26.3869 15 28.6761 15.9482 30.364 17.636C32.0518 19.3239 33 21.6131 33 24V30"
      stroke="#6600CC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33 31C33 31.5304 32.7893 32.0391 32.4142 32.4142C32.0391 32.7893 31.5304 33 31 33H30C29.4696 33 28.9609 32.7893 28.5858 32.4142C28.2107 32.0391 28 31.5304 28 31V28C28 27.4696 28.2107 26.9609 28.5858 26.5858C28.9609 26.2107 29.4696 26 30 26H33V31ZM15 31C15 31.5304 15.2107 32.0391 15.5858 32.4142C15.9609 32.7893 16.4696 33 17 33H18C18.5304 33 19.0391 32.7893 19.4142 32.4142C19.7893 32.0391 20 31.5304 20 31V28C20 27.4696 19.7893 26.9609 19.4142 26.5858C19.0391 26.2107 18.5304 26 18 26H15V31Z"
      stroke="#6600CC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Headphone;
